import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ComponentForm, ComponentPicker } from "src/components/content-builder";

interface ColumnProps {
  column: any;
  onUpdate: (updatedColumn: any) => void;
}

export const EditorColumn: React.FC<ColumnProps> = ({ column, onUpdate }) => {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState<'picker' | 'form'>('picker');
  const [selectedComponent, setSelectedComponent] = useState<any>(null);

  const handleOpen = () => {
    setStep('picker');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedComponent(null);
  };

  const handleSelect = (component: any) => {
    setSelectedComponent(component);
    setStep('form');
  };

  const handleSave = (data: any) => {
    onUpdate({ ...column, component: { ...selectedComponent, data } });
    setOpen(false);
    setSelectedComponent(null);
  };

  const handleEdit = () => {
    setSelectedComponent(column.component);
    setStep('form');
    setOpen(true);
  };

  const handleRemove = () => {
    onUpdate({ ...column, component: null });
  };

  return (
    <Box className="editor-column" p={2} border={1} borderColor="grey.300" borderRadius={2}>
      {!column.component ? (
        <Box display="flex" justifyContent="center">
          <IconButton onClick={handleOpen}><AddIcon /></IconButton>
        </Box>
      ) : (
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography className="component-label">{column.component.name} ({column.component.data.id})</Typography>
          <Box>
            <IconButton onClick={handleEdit}><EditIcon /></IconButton>
            <IconButton onClick={handleRemove}><DeleteIcon /></IconButton>
          </Box>
        </Box>
      )}

      <Dialog 
        open={open} 
        onClose={handleClose} 
        fullWidth 
        maxWidth="sm" 
        disableEnforceFocus
        disableAutoFocus
        disableRestoreFocus
      >
        <DialogTitle>{step === 'picker' ? 'Select Component' : selectedComponent?.name}</DialogTitle>
        <DialogContent>
          {step === 'picker' && <ComponentPicker onSelect={handleSelect} onClose={handleClose} />}
          {step === 'form' && selectedComponent && (
            <ComponentForm
              component={selectedComponent}
              initialData={column.component?.data ?? null}
              onSave={handleSave}
              onClose={handleClose}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
};
